<template>
    <b-table-lite
        bordered
        no-border-collapse
        striped
        outlined
        :items="items"
        :fields="fields"
        sticky-header="400px"
        table-class="table-va-middle"
        class="shadow-sm"
    />
</template>

<script>
import format from "@/utils/format";

const numberFormater = value => format(value);

export default {
    name: "TriaxialJointsTable",
    computed: {
        items() {
            return this.$store.state.julho_14.simulator.results.triaxialjoints;
        },
        fields() {
            return [
                {
                    key: "ID",
                    label: "Medidor"
                },
                {
                    key: "closing",
                    label: "Fechamento (mm)",
                    formatter: numberFormater
                },
                {
                    key: "sliding",
                    label: "Deslizamento (mm)",
                    formatter: numberFormater
                },
                {
                    key: "settlement_diff",
                    label: "Recalque diferencial (mm)",
                    formatter: numberFormater
                }
            ];
        }
    }
};
</script>
